import React from "react";
import { Outlet } from "react-router-dom"; // Import Outlet here

import "./layout.scss";
const Layout = () => {
  return (
    <div id="app-layout">
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
